<template>
  <div
    @click="$router.push({ path: '/marketplace' })"
    class="rounded-lg bg-ontick-steel-100 px-5 py-6 shadow-md dark:bg-ontick-graphite-500"
  >
    <div class="flex flex-col items-center justify-center space-y-6">
      <h2 class="text-2xl font-semibold text-gray-300">
        Área de investimentos
      </h2>
      <span v-html="$icons.new_investment"></span>

      <p
        class="whitespace-normal text-center text-ontick-steel-900 dark:text-gray-300"
      >
        Nesta área você vai ativar e controlar todos os seus investimentos.
        Comece agora!
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
